module.exports = __webpack_public_path__ + "img/info-big.081ecffa.png";